"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useAutoFocus = function (autoFocus, elementRef) {
    var onFocus = react_1.useCallback(function () {
        var element = elementRef.current;
        if (element) {
            element.focus();
        }
    }, [elementRef]);
    react_1.useEffect(function () {
        if (autoFocus) {
            onFocus();
        }
    }, [autoFocus, onFocus]);
    return onFocus;
};
exports.default = useAutoFocus;
